// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2d7k5","label":"styles_label__1Q9DD"};